import React from 'react'

import RoomTypeItemBoxSkeleton from './RoomTypeItemBox.skeleton'
import useStyles from './styles/RoomTypesList.styles'

interface RoomTypesListSkeletonProps {}
const RoomTypesListSkeleton: React.FC<RoomTypesListSkeletonProps> = ({}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.listContainer}>
        {Array(6)
          .fill('')
          .map((item, index) => (
            <RoomTypeItemBoxSkeleton
              key={`roomtypebox-skeleton${item}${index.toString()}`}
            />
          ))}
      </div>
    </div>
  )
}

export default RoomTypesListSkeleton
